<template>
  <container width="600px">
    <SectionHeader>
      <h1>
        Steam Account Transfer
      </h1>
    </SectionHeader>
    <SectionWrapper class="whiteframe shadowframe">
      <Icon type="warning" color="red" :size="3" />
      <p>
        <b>
          This service is currently unavailable as we are fixing some issues
          related to newly introduced Ylands name feature.
        </b>
      </p>
      <p>
        There will be an announcement made via Ylands social channels when the
        service becomes available again. We are sorry for the inconvenience.
      </p>
    </SectionWrapper>
  </container>
</template>

<script>
export default {
  name: "out-of-order"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
